import './styles/NoItems.scss';

import { SentimentDissatisfied } from '@mui/icons-material';
import { Button, Divider, Grid, Paper } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { translations } from 'locales/i18n';

interface Props {
  icon?: React.ReactNode;
  message?: string;
}

export function NoItems(props: Props) {
  const { t } = useTranslation();

  return (
    <Grid container component={Paper} className="no-items">
      <Grid container justifyContent="center" className="no-items__icon">
        {props.icon || <SentimentDissatisfied />}
      </Grid>
      <Grid container className="no-items__message" direction={'column'} gap={2}>
        <Grid item xs>
          {props.message || t(translations.common.emptyList())}
        </Grid>
      </Grid>
    </Grid>
  );
}
